// extracted by mini-css-extract-plugin
module.exports = {"divider":"AvailableProgramsTable_divider__2mkoE","tableContainer":"AvailableProgramsTable_tableContainer__26EOM","cell":"AvailableProgramsTable_cell__RF-ns"};